export default "__VITE_ASSET__BfHtsySp__"